export const BROWSER_CONFIG_SETTINGS_KEY = 'search-card-fragment';
export const NUMBER_OF_VISIBLE_PROMOTIONS  = 4;

export type TPlural = [string, string, string];

export const flat: TPlural = ['такая же квартира', 'такие же квартиры', 'таких же квартир'];
export const suburban: TPlural = ['такой же объект', 'таких же объекта', 'таких же объектов'];
